import { render, staticRenderFns } from "./GiftForm.vue?vue&type=template&id=08448dc0&scoped=true"
import script from "./GiftForm.vue?vue&type=script&lang=js"
export * from "./GiftForm.vue?vue&type=script&lang=js"
import style0 from "./GiftForm.vue?vue&type=style&index=0&id=08448dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08448dc0",
  null
  
)

export default component.exports